import { backdropAtom, SHIPPING_TYPE, targetShippingSeqAtom } from '@/commons/constants';
import ShippingContainer from '@/containers/ShippingContainer';
import { deleteShipping, planShippingListAtom } from '@/interfaces/plan/shipping';
import {
  Button,
  Card,
  CircularProgress,
  Collapse,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as _ from 'lodash';
import { CustomTextField } from '@/components/exec/common/CustomMui';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import { centerListAtom } from '@/interfaces/plan/manage';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import DeleteIcon from '@mui/icons-material/Delete';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  // flex-direction: column;
  gap: 1rem;
  overflow:hidden;
  .row{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
  }
`;

const ShippingList = styled(Card)`
    width: 22rem;
    height: 100%;
    list-style-type: none;
    padding:0;
    margin:0;
    border: 1px solid #bbb;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .head{
      padding: 0.5rem;
      width: 100%;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background:rgba(82, 133, 164, 0.87);
      color: #ffffff;
    }
    > .body {
      flex-grow: 1;
      width: 100%;
      height: 100%;
      overflow-y:scroll;
      display: flex;
      flex-direction: column;
    }
    .searchTitle {
      display: grid;
      grid-template-columns: 5rem minmax(1rem,auto) 5rem;
      align-items: center;
      height: 4rem;
      border-bottom: 1.5px solid #bbb;
      .col{
        padding:0.5rem 0.25rem;
      }
    }
    .listItem{
      border-top: 1px solid #bbb;
    }
    .listItem:first-child{
      border-top:0;
    }
    .listItem:last-child{
      border-bottom: 1.5px solid #bbb;
    }
    .li {
      display: grid;
      grid-template-columns: 5rem minmax(1rem,auto) 5rem;
      min-height: 3rem;
      align-items: center;
      > span {
        display: table-cell;
        height: 2rem;
        line-height: 1rem;
        text-align: center;
        vertical-align: middle;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0.5rem;
        border-right: 1px solid #bbb;
      }
      > span:nth-child(2){
        text-align:left;
      }
      > span:last-child{
        border:0;
      }
    }
    div > .li:hover, .sub:hover{
      background:rgba(50,50,180,0.1);
    }
    .sub{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap:0.25rem;
      // grid-template-columns: 2rem minmax(1rem,auto) 5rem 7rem;
      border-top: 0.5px dotted #ccc;
      min-height: 3rem;

    }
    
`;
interface SubItem {
  t_shipping_seq: number;
  option: { shipping_type: number; level: number };
  exec_info: any;
  use_flag: number;
}

interface ShippingItem {
  seq: number;
  name: string;
  center_name?: string;
  date: string;
  sub: SubItem[];
  complete: boolean;
}

export default function ResultList() {
  const setBackdrop = useSetAtom(backdropAtom);
  const { data: shippingList, isLoading, refetch } = useAtomValue(planShippingListAtom);
  const { data: centerList } = useAtomValue(centerListAtom);

  const [contents, setContents] = useState([]);
  const [center, setCenter] = useState<string>();
  const [name, setName] = useState<string>();
  const [date, setDate] = useState<string>();

  useEffect(() => {
    if (shippingList && shippingList.length > 0) {
      const temp: ShippingItem[] = [];
      let filterdList = shippingList;
      if (center && center.length > 0) {
        filterdList = _.filter(filterdList, function (o) {
          return o.center_name?.indexOf(center) > -1;
        });
      }
      if (name && name.length > 0) {
        filterdList = _.filter(filterdList, function (o) {
          return o.name.indexOf(name) > -1;
        });
      }
      if (date && date.length > 0) {
        filterdList = _.filter(filterdList, function (o) {
          return o.date.indexOf(date) > -1;
        });
      }
      _.forEach(_.groupBy(filterdList, 'seq'), (val, key) => {
        const sub: SubItem[] = _.sortBy(
          _.map(val, (mval) => _.pick(mval, ['t_shipping_seq', 'option', 'exec_info', 'use_flag'])),
          't_shipping_seq',
        );
        temp.push({
          seq: Number(key),
          name: val[0].name,
          center_name: val[0].center_name,
          date: val[0].date,
          sub,
          complete: _.find(sub, ['use_flag', 1]) ? true : false,
        });
      });
      setContents(_.sortBy(temp, 'seq').reverse());
      setBackdrop(false);
    }
  }, [shippingList, center, name, date]);

  return (
    <MainWrap>
      <ShippingList>
        <div className="head">
          <Typography variant="h6">실행 목록</Typography>
        </div>
        <div className="searchTitle">
          <div className="col">
            {centerList && (
              <FormControl size="small" sx={{ width: '4.5rem' }}>
                <InputLabel id="demo-simple-select-label">센터</InputLabel>
                <Select label="센터" value={center} onChange={(e) => setCenter(e.target.value)}>
                  <MenuItem value={null}>선택안함</MenuItem>
                  {centerList.map((item: any, index: number) => (
                    <MenuItem key={index} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>
          <div className="col">
            <CustomTextField
              size="small"
              label="이름"
              fullWidth
              variant="outlined"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col">
            <CustomTextField
              size="small"
              label="배송일"
              fullWidth
              variant="outlined"
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
        </div>
        <div className="body">
          {!isLoading &&
            contents &&
            contents.length > 0 &&
            contents.map((item: ShippingItem, index: number) => {
              return <ListItem key={index} item={item} refetch={refetch} setBackdrop={setBackdrop} />;
            })}
          {isLoading && (
            <div
              style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <CircularProgress />
            </div>
          )}
        </div>
      </ShippingList>
      <ShippingContainer mode="in" />
    </MainWrap>
  );
}

const ListItem = ({ item, refetch, setBackdrop }: { item: ShippingItem; refetch: any; setBackdrop: any }) => {
  const [targetShippingSeq, setTargetShippingSeq] = useAtom(targetShippingSeqAtom);
  const [show, setShow] = useState<boolean>(false);

  const handleDeleteClick = async (t_shipping_seq: number) => {
    setBackdrop && setBackdrop(true);
    await deleteShipping(t_shipping_seq, item.seq);
    refetch && refetch();
  };

  const handleViewClick = (seq: number) => {
    setTargetShippingSeq(seq);
  };

  return (
    <div className="listItem">
      <div className="li" onClick={() => setShow(!show)}>
        <Typography component="span">{item.center_name}</Typography>
        <Typography component="span" style={{ display: 'flex', alignItems: 'center' }}>
          {item.complete ? <BeenhereIcon color="success" /> : ''}
          {item.name}
        </Typography>
        <Typography component="span">{item.date}</Typography>
      </div>
      <Collapse in={show}>
        {item.sub.map((sItem: SubItem, sIndex: number) => {
          return (
            <div
              key={sIndex}
              className="sub"
              style={targetShippingSeq === sItem.t_shipping_seq ? { background: 'rgba(50,50,180,0.2)' } : {}}
            >
              <div
                style={{ paddingLeft: '0.25rem', display: 'flex', justifyContent: 'flex-end' }}
                onClick={() => handleViewClick(sItem.t_shipping_seq)}
              >
                <SubdirectoryArrowRightIcon htmlColor="#999" />
              </div>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '0.15rem' }}
                onClick={() => handleViewClick(sItem.t_shipping_seq)}
              >
                <Typography component="span">
                  {SHIPPING_TYPE[sItem.option?.shipping_type]}
                  {sItem.option?.shipping_type === 1 || sItem.option?.shipping_type === 2
                    ? sItem.option?.level === 1
                      ? ' 시/도'
                      : ' 구/군'
                    : ''}
                </Typography>
              </div>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '0.15rem' }}
                onClick={() => handleViewClick(sItem.t_shipping_seq)}
              >
                <LocalShippingIcon htmlColor="#999" />
                <Typography component="span">
                  {sItem.exec_info?.count.car.exec} / {sItem.exec_info?.count.car.org}
                </Typography>
              </div>
              <div
                style={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: '0.15rem' }}
                onClick={() => handleViewClick(sItem.t_shipping_seq)}
              >
                <EmojiTransportationIcon htmlColor="#999" />
                <Typography component="span">
                  {sItem.exec_info?.count.dest.exec} / {sItem.exec_info?.count.dest.org}
                </Typography>
              </div>
              <div
                style={{
                  paddingRight: '0.25rem',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                {sItem.use_flag === 1 ? (
                  <BeenhereIcon color="success" />
                ) : (
                  <DeleteIcon htmlColor="#999" onClick={() => handleDeleteClick(sItem.t_shipping_seq)} />
                )}
              </div>
            </div>
          );
        })}
      </Collapse>
    </div>
  );
};
